import React, { useEffect, useState } from "react";
import axios from 'axios';
// import { render } from 'react-dom';
// import { Link } from "@reach/router";

const Posts = () => {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        const getPosts = async () => {
            const response = await axios.get(`https://worker.rajshah001.workers.dev/`)
            const postsResp = await response.data;
            setPosts(postsResp);
        }
        getPosts();
    }, []);

    return (
        <div>
            {posts.map((post) => (
                <li>{post.title}</li>
            ))}
        </div>
    );
};

export default Posts;
// render(<App />, document.querySelector('#app'));